/**
 * Pantalla con el pricing de la aplicación. Enlace con Contacto de Mixoutfit o a un enlace
 * de Stripe para el plan de pago.
**/

import { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import "../assets/Pricing.css";
import tick from "../assets/icons/tick-verde.svg";

function Pricing() {
  /*********************************** VARIABLES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  const [billing, setBilling] = useState('MENSUAL');

  /***********************************************************************************************/
  /***********************************************************************************************/

  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //Retorna un valor(precio) según el tipo de recurrencia en el pago
  const getProPrice = () => {
    return billing === 'ANUAL' ? "16,67" : 19;
  };

  //Muestra un popup cuando se selecciona el plan gratis
  const handleChoosePlan = (plan) => {
    alert(`Has elegido el plan: ${plan}`);
  };

  //Redirige a la página de contacto de Mixoutfit (para plan de Empresa)
  const navigateContacto = () => {
    window.open('https://www.mixoutfit.com/contacto', '_blank');
  };

  //Redirige al enlace de Stripe (para el plan Pro)
  const navigatePagar = () => {
    window.open('https://buy.stripe.com/3csg1U1dtf8G5R6146' , '_blank');
  };

  /***********************************************************************************************/
  /***********************************************************************************************/

  return (
    <div className="pricing">
      <Navbar />
      <main className="pricing-main">
        <Sidebar />
        <div className="pricing-container">
          <div className="espacio-containers"></div>
          {/* Toggle buttons container */}
          <div className="pricing-container-toggleContainer">
            <div className="pricing-container-toggle_periodo">
              <button
                onClick={() => setBilling('ANUAL')}
                className={billing === 'MENSUAL'? "pricing-container-toggle_periodo--boton" : "pricing-container-toggle_periodo--botonaAct"}
              >
                ANUAL
              </button>
              <button
                onClick={() => setBilling('MENSUAL')}
                className={billing === 'ANUAL'? "pricing-container-toggle_periodo--boton" : "pricing-container-toggle_periodo--botonaAct"}
              >
                MENSUAL
              </button>
            </div>
          </div>
          <div className="espacio-containers"></div>
          <div className="espacio-containers"></div>
          {/* Cards container */}
          <div className="pricing-container-container_cartas">
            {/* FREE Card */}
            <div className="pricing-container-container_cartas--carta">
              <h5 className>MixOutfit FREE</h5>
              <p></p>
              <h4>0€</h4>
              <p></p>
              <ul className="pricing-container-container_cartas--carta__checklist">
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />1 crédito = 3 generaciones
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />4 Grupos de Edad
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />Modelos FREE
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />MixOutfit Slow Creation
                </li>                  
              </ul>
              <button
                onClick={() => handleChoosePlan('FREE')}
                className="pricing-container-container_cartas--carta__boton"
              >
                EMPEZAR
              </button>
            </div>

            {/* PRO Card */}
            <div className="pricing-container-container_cartas--carta">
              <div className="pricing-container-container_cartas--topper">
                POPULAR
              </div>
              <h5 >MixOutfit PRO</h5>
              <p></p>
              <div className="pricing-container-container_cartas--precio">
                <h4>{getProPrice()}€</h4>
                <span className="pricing-container-container_cartas--precioTexto">/mes</span>
              </div>
              {billing === 'ANUAL' && (
                <p className="pricing-container-container_cartas--texto_ahorro">Ahorra 12%</p>
              )}
              <p></p>
              <ul className="pricing-container-container_cartas--carta__checklist">
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />
                  <span>100 créditos = 50 </span>
                  <span style={{ paddingLeft: '23px' }}>generaciones/mes</span>
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />4 Grupos de Edad
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />Más de 60 modelos
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />MixOutfit Fast Creation
                </li>  
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />Licencia de Uso Comercial
                </li>                  
              </ul>
              <button
                onClick={navigatePagar}
                className="pricing-container-container_cartas--carta__boton"
              >
                EMPEZAR</button>
            </div>
            {/* Enterprise Card */}
            <div className="pricing-container-container_cartas--carta">
              <p></p>
              <h6>¿Eres una Marca o Agencia?</h6>
              <h5>ENTERPRISE</h5>
              <p></p>
              <ul className="pricing-container-container_cartas--carta__checklist">
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />Proyecto Customizado
                </li>
                <li>
                  <img src={tick} alt="icono" className="tick-lista" />Presupuesto en minutos
                </li>                 
              </ul>
              <button
                onClick={navigateContacto}
                className="pricing-container-container_cartas--carta__botonAlt"
              >
                CONTACTO</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Pricing;
